import * as PIXI from 'pixi.js';

// UBuilder-Lite-only renderer. Uses transparent: true so the CSS-rendered
// grid on the outer div shows through the Pixi canvas. Routed to from
// renderer.ts:setupRenderer when state().app.isUbuilderLite is true; legacy
// editor keeps the original opaque renderer untouched.
export function setupRendererLite(width: number, height: number) {
  return PIXI.autoDetectRenderer(
    width,
    height,
    { antialias: true, transparent: true },
  );
}
